export default __webpack_public_path__ + "static/media/image-xx99-mark-one.76443c3b.jpg";